import { render, staticRenderFns } from "./RealName.vue?vue&type=template&id=121edb6e&scoped=true"
import script from "./RealName.vue?vue&type=script&lang=js"
export * from "./RealName.vue?vue&type=script&lang=js"
import style0 from "./RealName.vue?vue&type=style&index=0&id=121edb6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121edb6e",
  null
  
)

export default component.exports